export enum CertificateFamilies {
  REGISTRATION = 'Registration',
  OFFICIAL = 'Official',
}
